import React, { Component } from 'react';
class Banner extends Component {
    state = {  }
    render() { 
        return (
            <React.Fragment>
            <header className="header">
                <div className="exten-banner">
                    <div className="header-green-container"></div>
                    <div className="banner-text">
                        <div className="banner-tittle">
                            <h1 className="fuente-monserrat"> La Extensión </h1>
                        </div>
                        <div className="banner-descrip parrafo-grande">
                            <p align="justify" className="fuente-monserrat">
                                La Extensión tiene como objeto lograr la interacción creadora y crítica del instituto universitario con la comunidad intra y extra universitaria, nacional e internacional, para promover y fomentar el conocimiento, el desarrollo cultural; científico, tecnológico, humanístico y social; orientar la transformación de la sociedad y mejorar continuamente la calidad de vida de sus integrantes. Las actividades de Extensión atienden las áreas académica, sociocultural, comunitaria, recreativa, entre otras y están conformadas por diplomados, talleres, cursos, seminarios y demás eventos académicos que abarcan distintas propuestas para diferentes necesidades. En el Instituto Universitario de Diseño Las Mercedes estas actividades están bajo la responsabilidad de la Comisión de Extensión adscrita a la Dirección Académica. 
                            </p>
                        </div>
                    </div>
                </div>
            </header>
            </React.Fragment>
        );
    }
}
 
export default Banner;


// WEBPACK FOOTER //
// ./src/site/Componentes/Extension/Banner.jsx